export class EvalValidationRule {
    name = 'eval';
    validate(field, rule, value, object) {
        //Vars
        let tExpression = rule.props.expression;
        let tMessage = utils.format('This is not a valid {0}', field.displayName);
        //Message
        if (rule.message) {
            tMessage = utils.format(rule.message, field.displayName);
        }
        //Check
        if (utils.isNullOrEmpty(tExpression)) {
            return {
                isValid: true
            };
        }
        if (utils.evalExpression(object, tExpression)) {
            return {
                isValid: false,
                message: tMessage
            };
        }
        return {
            isValid: true
        };
    }
}
